<template>
  <div class="home">
    <Header type='login-header' />
    <AccountLayout class="register-content">
      <!-- 登陆框 -->
      <div class="account-dialog">
        <div class="title">{{ $t('register.registerTitle') }}</div>
        <!-- 邮箱 -->
        <BasicInput
          type="text"
          icon-type="email"
          class="account-input account-email"
          :placeValue="$t('register.registerPlaceHolder')"
          v-model="inputEmail"
        ></BasicInput>
        <div
          v-if="EmailErrMsg"
          class="account-error align-center justify-start "
        >
          <i class="el-alert__icon el-icon-error"></i>
          <span class="EmailErrorMsg margin-left-10">{{ EmailErrMsg }}</span>
        </div>
        <!-- 手机号 -->
        <BasicInput
          class="margin-top-15 margin-left-30 margin-right-30"
          type="text"
          icon-type="tel"
          placeValue="用于验证和找回密码，请填写真实手机"
          v-model="tel"
        ></BasicInput>
        <div
          v-if="TelErrMsg"
          class="account-error align-center justify-start "
        >
          <i class="el-alert__icon el-icon-error"></i>
          <span class="EmailErrorMsg margin-left-10">{{ TelErrMsg }}</span>
        </div>
        <!-- 图片验证码 -->
        <div class="captcha">
          <el-input
            class="account-input account-email"
            v-model="imageCode"
            autocomplete="off"
            placeholder="验证码"
            style="width: 70px;"
          ></el-input>
          <img class="image" :src="imgUrl" />
          <p class="image-remark">看不清？<span style="color: #12B8B6; cursor: pointer;text-decoration: underline;" @click="queryimageCode">换一张</span></p>
        </div>

        <div
          v-if="verifyErrorMsg"
          class="account-error"
        >
          <i class="el-alert__icon el-icon-error"></i>
          <span class="EmailErrorMsg">{{ verifyErrorMsg }}</span>
        </div>

        <!-- 验证&邮件码 -->
        <VerifyCodeByGVerify
          :siteKey="siteKey"
          type="text"
          icon-type="emailCode"
          class="account-input password-email"
          v-model="verifyCode"
          :tel="tel"
          @verifyCodeTip="verifyCodeTip"
          :placeValue="$t('register.verfPlaceHolder')"
        ></VerifyCodeByGVerify>
        <div
          v-if="VerifyCodeErrMsg"
          class="account-error align-center justify-start "
        >
          <i class="el-alert__icon el-icon-error"></i>
          <span class="VerifyCodeErrMsg margin-left-10">{{ VerifyCodeErrMsg }}</span>
        </div>
        <!-- 密码 -->
        <BasicInput
          type="password"
          icon-type="password"
          class="account-input password-email"
          v-model="inputPw"
          :placeValue="$t('register.newPw')"
        ></BasicInput>
        <div
          v-if="PwErrMsg"
          class="account-error align-center justify-start "
        >
          <i class="el-alert__icon el-icon-error"></i>
          <span class="PwErrMsg margin-left-10">{{ PwErrMsg }}</span>
        </div>
        <!-- 第二密码 -->
        <BasicInput
          type="password"
          icon-type="password"
          class="account-input password-email"
          v-model="inputSePw"
          :placeValue="$t('register.confirmPw')"
        ></BasicInput>
        <div
          v-if="secPsErrMsg"
          class="account-error"
        >
          <i class="el-alert__icon el-icon-error"></i>
          <span class="secPsErrMsg margin-left-10">{{ secPsErrMsg }}</span>
        </div>
        <!-- 用户协议 -->
        <div class="protocol-wrap">
          <el-radio
            v-model="agreeProtocol"
            label="1"
            class="margin-right-10 user-protocol-radio"
          >
            {{$t('register.agreeProtocol')}}
          </el-radio>
          <a
            class="agree-link bonus-color "
            target="_blank"
            href="https://bonuscloud.net/protocol"
          > {{$t('register.agreeLink')}} </a>
        </div>
        <div
          class="sign-up-button bonus-cursor"
          v-on:click="signUp"
        >{{ $t('register.signButton') }}</div>
        <div
          class="login-sign-wrap bonus-cursor"
          v-on:click="login"
        >{{ $t('register.redirectLogin') }}</div>
      </div>
    </AccountLayout>
    <Footer />
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/Header.vue";
import AccountLayout from "@/components/AccountLayout.vue";
import BasicInput from "@/components/User/BasicInput.vue";
import VerifyCodeByGVerify from "@/components/Common/VerifyCodeByGVerify.vue";
import { mapMutations, mapActions, mapState } from "vuex";
import { Message } from "element-ui";
import { SITEKEY } from "../../config/contant.js";
import Footer from "@/components/Common/Footer.vue";
import { reqUrl } from '../../utils/env';
import axios from 'axios';

export default {
  name: "SignUp",
  data() {
    return {
      //输入错误信息时提示
      EmailErrMsg: "",
      TelErrMsg: "",
      ImageCodeErrMsg: "",
      VerifyCodeErrMsg: "",
      PwErrMsg: "",
      secPsErrMsg: "",
      verifyErrorMsg: "",
      // 输入的注册字段
      inputEmail: "",
      verifyCode: "",
      inputPw: "",
      inputSePw: "",
      //注册可点击状态
      isSignUpDisable: false,
      agreeProtocol: false,
      tel: "", //手机号
      imageCode:'',
      imgUrl: '',
      imageCodeId: ''
    };
  },
  components: {
    Header,
    AccountLayout,
    BasicInput,
    VerifyCodeByGVerify,
    Footer,
  },
  created() {
    this.VerifyCodeErrMsg = '';
    this.PwErrMsg = '';
    this.queryimageCode();
  },
  computed: mapState({
    imageCodeSrc: (state) => state.signUp.imageCodeSrc,
    siteKey() {
      return SITEKEY.LOW;
    },
  }),
  methods: {
    ...mapActions(["ajaxSignUp"]),
    // 登录
    login() {
      this.$router.push({ name: "login" });
    },
    // 注册
    signUp() {
      const {
        inputEmail,
        verifyCode,
        inputPw,
        inputSePw,
        isSignUpDisable,
        tel,
        imageCodeId,
        imageCode
      } = this;

      // 避免多次点击
      if (isSignUpDisable) {
        return true;
      }

      if(!inputEmail) {
        this.EmailErrMsg = "请输入邮箱";
        return true;
      } else {
        // 邮箱验证-----后续建议提出来统一维护
        const emailRule = /^([\.a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((\.[a-zA-Z0-9_-]{2,6}){1,2})$/;
        if (emailRule.test(inputEmail)) {
          this.EmailErrMsg = "";
        } else {
          this.isSignUpDisable = false;
          this.EmailErrMsg = "请输入正确格式的邮箱";
          return true;
        }
      }

      if (!tel) {
        return this.TelErrMsg = "请输入手机号";
      } else {
        this.TelErrMsg = "";
      }

      if(!this.imageCode) {
        this.verifyErrorMsg = '请输入图片验证码'
        return true;
      } else {
        this.verifyErrorMsg = '';
      }

      // 邮箱验证码验证
      if (verifyCode) {
        this.VerifyCodeErrMsg = "";
      } else {
        this.isSignUpDisable = false;
        this.VerifyCodeErrMsg = "请输入手机验证码";
        return true;
      }

      if (inputPw && inputPw.length >= 6) {
        this.PwErrMsg = "";
      } else {
        this.isSignUpDisable = false;
        this.PwErrMsg = "请输入密码";
        inputPw.length < 6 &&
          (this.PwErrMsg = "请输入长度大于6位的密码");
        return true;
      }

      if(!inputSePw) {
        this.secPsErrMsg = "请输入第二次确认密码";
        return true;
      } else {
        if (inputSePw && inputSePw === inputPw) {
          this.secPsErrMsg = "";
        } else {
          this.isSignUpDisable = false;
          this.secPsErrMsg =
            inputSePw === inputPw
              ? "第二次密码输入错误"
              : "第二次密码输入错误";
          return true;
        }
      }

      if (!this.agreeProtocol) {
        Message({
          message: "还没有同意用户协议",
          type: "error",
        });
        return true;
      }

      this.ajaxSignUp({
        email: inputEmail,
        emailVerifyCode: verifyCode,
        password: inputPw,
        rePassword: inputSePw,
        refer: this.$route.query.refer || "",
        tel,
        captcha_id:imageCodeId,
        captcha:imageCode
      }).then((res) => {
        this.isSignUpDisable = false;
        if (res && res.code && res.code === 201) {
          Message({
            message: res.message || '恭喜您，注册已成功',
            type: "success",
          });
          setTimeout(() => {
            this.$router.push({ name: "login" });
          }, 3000);
        } else {
          this.queryimageCode();
          Message({
            type: "error",
            message: res.message || "注册失败，请重试",
          });
        }
      });
    },
    queryimageCode() {
      this.imageCode = '';
      try {
        axios.get(`${reqUrl}/api/getCaptcha`).then(res=>{
          this.imgUrl = res.data.data.Base64Blob;
          this.imageCodeId = res.data.data.CaptchaId;
        })
      } catch (error) {
          this.imgUrl = '';
          this.imageCodeId = '';
      }
    },
    // 发送邮件码错误提示
    verifyCodeTip(error) {
      console.log(error);
      if (error.type === "captcha") {
        this.VerifyCodeErrMsg = error.message;
      } else if (error.type === "tel") {
        this.TelErrMsg = error.message;
      }
    },
  },
};
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus">
.register-content.account-layout {
  height: 60vw;
}

.account-dialog {
  width: 52%;
  max-width: 430px;
  background: #fff;
  border: 1px solid #e3e3e7;
  margin: 18% 0 0 10%;
}

.account-dialog .title {
  font-family: PingFangSC-Semibold;
  color: #65686A;
  font-size: 12px;
  line-height: 12px;
  padding: 30px 0 30px 40px;
  text-align: left;
}

.account-dialog .title {
  font-size: 14px;
  line-height: 14px;
  padding: 35px 0 35px 30px;
  text-align: left;
}

.input-wrap {
  margin: 10px 40px 20px 40px;
}

.sign-up-button {
  box-sizing: border-box;
  margin: 35px 30px 5px 30px;
  background-image: linear-gradient(-180deg, #15BCAD 2%, #10B2CB 100%);
  line-height: 30px;
  height: 30px;
  font-family: PingFangSC-Regular;
  font-size: 12px;
  color: #FFFFFF;
  text-align: center;
  line-height: 30px;
}

@media screen and (min-width: 1200px) {
  .account-dialog {
    width: 350px;
    // height: 320px;
  }
}

@media screen and (max-width: 1200px) {
  .account-dialog {
    width: 300px;
    max-width: 420px;
    background: #fff;
    border: 1px solid #e3e3e7;
    margin: 120px 0 0 98px;
  }
}

.account-input {
  margin: 0 30px;
}

.password-email, .forget-code {
  margin-top: 15px;
}

.login-sign-wrap {
  font-family: PingFangSC-Regular;
  font-size: 12px;
  color: #13b8bc;
  text-align: right;
  line-height: 36px;
  margin: 0 30px 35px;
}

.account-error {
  box-sizing: border-box;
  padding: 5px 30px 0;
  color: #EE4035;
  font-size: 10px;
}

.el-alert__icon {
  font-size: 10px;
}

.protocol-wrap {
  margin: 15px 30px;
  text-align: left;
  line-height: 14 px;
  font-size: 12px !important;
}

.protocol-wrap .el-radio__label {
  font-size: 12px !important;
}

.is-mobile .register-content .account-dialog {
  margin: 10px auto;
  width: 100%;
}

.is-mobile .register-content.register-content {
  height: auto;
}

.user-protocol-radio {
  margin-right: 0px !important;
}

.captcha {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 30px;
  .image {
    width: 90px;
    height: 30px;
    background: #F7F7F7;
    margin-top: 12px;
  }
  .image-remark {
    font-size: 12px;
    margin-top: 12px;
  }
}
</style>

<style lang="stylus">
  .captcha {
    .el-input__inner {
      width: 100px;
      height: 30px;
      border-radius: 0px;
      margin-top: 12px;
    }
  }
</style>